export default {
    props: {
        filterField: {
            type: String,
            default: undefined,
            kComposite: 'filter.field'
        },
        filterFilters: {
            type: Array,
            default: undefined,
            kComposite: 'filter.filters'
        },
        filterLogic: {
            type: String,
            default: undefined,
            kComposite: 'filter.logic'
        },
        filterOperator: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filter.operator'
        },
        filterValue: {
            type: [Object, Date, Number, String],
            default: undefined,
            kComposite: 'filter.value'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Filter.js